import React, { useState } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import { Document as DocxDocument, Packer, Paragraph, HeadingLevel } from "docx";
import Modal from 'react-modal';
import "../Reports.css";

Modal.setAppElement('#root');

function OrderByIdReport() {
    const [orderId, setOrderId] = useState("");
    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const handleGenerateReport = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`https://monitor.dev.masiot.dmsolution.ru/api/v1/reports/order/${orderId}`);
            const orderData = response.data.split("\n").map(line => line.split(": ")[1]);
            setOrder({
                orderId: orderData[0],
                nameOrder: orderData[1],
                descriptionOrder: orderData[2],
                typeOrder: orderData[3],
                status: orderData[4]
            });
            setOrderId("");
        } catch (error) {
            if (error.response && (error.response.status === 500 || error.response.status === 400 || error.response.status === 404)) {
                setModalIsOpen(true);
            } else {
                console.error("Ошибка при получении данных:", error);
            }
        } finally {
            setLoading(false);
        }
    };

    const generateWordDocument = () => {
        const doc = new DocxDocument({
            sections: [
                {
                    properties: {},
                    children: [
                        new Paragraph({
                            text: "Отчет по заказу по идентификатору заказа",
                            heading: HeadingLevel.HEADING_1,
                        }),
                        new Paragraph({
                            text: `Идентификатор заказа: ${order.orderId}`,
                        }),
                        new Paragraph({
                            text: `Название заказа: ${order.nameOrder}`,
                        }),
                        new Paragraph({
                            text: `Описание заказа: ${order.descriptionOrder || "Нет описания"}`,
                        }),
                        new Paragraph({
                            text: `Тип заказа: ${order.typeOrder}`,
                        }),
                        new Paragraph({
                            text: `Статус: ${order.status}`,
                        }),
                    ],
                },
            ],
        });

        Packer.toBlob(doc).then(blob => {
            saveAs(blob, "order_by_id_report.docx");
        });
    };

    return (
        <div className="otch-report-card">
            <h2>📦 Отчет по идентификатору заказа</h2>

            <div className="otch-form-group">
                <input
                    type="text"
                    placeholder="Введите идентификатор заказа"
                    value={orderId}
                    onChange={(e) => setOrderId(e.target.value)}
                    className="otch-form-input"
                />
            </div>

            {order && (
                <div className="otch-result-container">
                    <p className="otch-result-text">
                        Заказ <span className="otch-highlight">{order.orderId}</span> - {order.nameOrder}
                        <br />
                        Тип: <span className="otch-highlight">{order.typeOrder}</span> | Статус: <span className="otch-highlight">{order.status}</span>
                    </p>
                </div>
            )}

            <div className="otch-button-container">
                <button
                    onClick={handleGenerateReport}
                    disabled={loading || !orderId.trim()}
                    className={`otch-button otch-generate-btn ${loading ? 'loading' : ''}`}
                >
                    {loading ? (
                        <>
                            <span className="otch-spinner"></span>
                            Загрузка...
                        </>
                    ) : (
                        "🔍 Найти заказ"
                    )}
                </button>
                {order && (
                    <button
                        onClick={generateWordDocument}
                        className="otch-button otch-word-download-btn"
                    >
                        📥 Скачать отчет
                    </button>
                )}
            </div>

            <Modal
                isOpen={modalIsOpen}
                onRequestClose={() => setModalIsOpen(false)}
                contentLabel="Ошибка сервера"
                className="otch-modal"
                overlayClassName="otch-modal-overlay"
            >
                <h2 className="otch-modal-title">⚠️ Ошибка</h2>
                <p className="otch-modal-message">Проверьте правильность введенного идентификатора заказа.</p>
                <button
                    onClick={() => setModalIsOpen(false)}
                    className="otch-modal-button"
                >
                    Понятно
                </button>
            </Modal>
        </div>
    );
}

export default OrderByIdReport;